import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'

import { team } from './animations'
import { cn } from '@/lib/utils'
import { WPImage, WPPageData } from '@/types'

export type TeamProps = HTMLAttributes<HTMLElement> &
  Partial<{
    pretitle?: string
    title?: string
    items?: {
      name: string
      role: string
      image: WPImage
    }[]
    theme: WPPageData['acf']['theme']
  }>

const Team = ({ items, theme }: TeamProps) => {
  return (
    <Motion animation={team}>
      {(motionRef) => (
        <section
          ref={motionRef}
          className={cn(
            theme === 'light'
              ? 'bg-dark-100 text-dark-600'
              : 'bg-dark-600 text-dark-100'
          )}
        >
          <Container>
            <Grid className="gap-[3.2rem]">
              {items?.map(({ name, role, image }, index) => (
                <div
                  key={`team-member-${index}`}
                  className={cn(
                    'col-span-2 flex flex-col gap-[1.6rem] leading-[1.1rem]',
                    index % 5 === 0 && 'col-start-0 lg:col-start-2'
                  )}
                  data-team-member
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="aspect-[3/4] h-auto w-full object-cover"
                  />
                  <div className="flex flex-col gap-[.8rem]">
                    <Typography variant="label" className="inline-block">
                      {name}
                    </Typography>
                    <Typography
                      variant="label"
                      className="inline-block font-bold"
                    >
                      {role}
                    </Typography>
                  </div>
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default Team
